/* eslint-disable no-unused-vars */
export enum RouteNames {
  LOGIN = '/login',
  CALLBACK = '/callback',
  DASHBOARD = '/dashboard',
  APPROVALS = '/approvals',
  MYACCESS = '/myaccess',
  FAMILY = '/family',
}
/* eslint-enable no-unused-vars */
